import { EntityQueue } from './entity.queue';

export interface EntityQueueCreateRequest {
  queue: Partial<EntityQueue>;
}

export interface EntityQueueUpdateRequest {
  queueId: string;
  queue: Partial<EntityQueue>;
}

export interface EntityQueueDeleteRequest {
  queueId: string;
}

export interface EntityQueueGetRequest {
  queueId: string;
}

export interface EntityQueueListRequest {
}

export enum EntityQueueCommandIds {
  NameExists = 'NameExists',
}

export interface EntityQueueNameExistsRequest {
  name: string;
  excludeQueueId?: string;
}
